import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  PostForgotQuery,
  PostForgotResponse,
} from '~/lib/services/api/user'

import type { PostForgotRequest } from '~/modules/forgot/forgot-form/constants'
import {
  useMutation,
} from '@tanstack/react-query'
import {
  postForgot,
} from '~/lib/services/api/user'

function useForgot() {
  const mutationFn: PostForgotQuery = async (newData: PostForgotRequest) => {
    const response = await postForgot(newData)
    return response.data
  }

  const options: UseMutationOptions<
    PostForgotResponse,
    DefaultError,
    PostForgotRequest,
    unknown
  > = {
    mutationFn,
  }

  return useMutation(options)
}

export default useForgot
